// Static external Melio URLs (same across all environments).
export const TERMS_OF_SERVICE_URL = 'https://melio.com/terms-of-service/';
export const PRIVACY_POLICY_URL = 'https://melio.com/privacy-policy/';
